import BulkOrderContainer from 'modules/order/containers/BulkOrderContainer';

const BulkOrderView = () => <BulkOrderContainer />;

export default BulkOrderView;
